<template>
    <el-drawer title="手动上传" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content" v-loading="dataLoading">
            <el-alert type="warning" show-icon :closable="false">
                <div slot="title">请确保上传为从支付平台直接导出的{{ time }}当日的交易对账单原文件</div>
            </el-alert>
            <el-form v-if="fileStatus" class="MT20" ref="formData" :model="formData" label-position="top">
                <el-form-item v-for="(item, index) in forms" :key="index" :prop="`path${item.type}`"
                    :rules="[{ required: item.status ? false : true, message: `请上传${item.name}交易对账单` }]">
                    <span slot="label">{{ item.name }}交易对账单：<small v-if="!item.status">{{ item.tips }}</small></span>
                    <el-upload v-if="!item.status" :ref="`upload${item.type}`" action :http-request="item.uploadFile" :accept="item.accept"
                        :disabled="item.uploadLoading" :before-upload="item.beforeUpload" :show-file-list="false">
                        <el-button size="mini" type="primary" icon="el-icon-upload" plain :loading="item.uploadLoading">
                            点击上传</el-button>
                        <div slot="tip">
                            <div>{{ item.fileName }}</div>
                        </div>
                    </el-upload>
                    <div v-else class="color-success"> <span class="el-icon-check"></span> 已下载成功，无需上传</div>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="onSubmit" :loading="btnLoading">提交</el-button>
        </div>
    </el-drawer>
</template>

<script>
import { uploadFile } from '@/assets/js/commonApi.js';
const _defaultFormData = {
    path1: '',
    path2: '',
    path3: '',
    path4: '',
    path5: ''
}
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            time: "",
            dataLoading: false,
            fileStatus: null,
            formData: {
                ..._defaultFormData
            }
        }
    },
    computed: {
        forms() {
            return [{
                type: 1,
                name: '支付宝',
                tips: '仅支持从支付宝导出的zip文件',
                accept: '.zip',
                uploadLoading: false,
                fileName: "",
                beforeUpload: (file) => {
                    return this.beforeUpload(file, 'zip');
                },
                uploadFile: (file) => {
                    this.uploadFileAction(file, 1);
                }
            }, {
                type: 2,
                name: '微信',
                tips: '仅支持从微信商户号导出的csv文件',
                accept: '.csv',
                uploadLoading: false,
                fileName: "",
                beforeUpload: (file) => {
                    return this.beforeUpload(file, 'csv');
                },
                uploadFile: (file) => {
                    this.uploadFileAction(file, 2);
                }
            }, {
                type: 3,
                name: '财付通',
                tips: '仅支持从微信商户号导出的csv文件',
                accept: '.csv',
                uploadLoading: false,
                fileName: "",
                beforeUpload: (file) => {
                    return this.beforeUpload(file, 'csv');
                },
                uploadFile: (file) => {
                    this.uploadFileAction(file, 3);
                }
            }, {
                type: 4,
                name: '抖音',
                tips: '仅支持从抖音平台导出的xlsx文件',
                accept: '.xlsx',
                uploadLoading: false,
                fileName: "",
                beforeUpload: (file) => {
                    return this.beforeUpload(file, 'xlsx');
                },
                uploadFile: (file) => {
                    this.uploadFileAction(file, 4);
                }
            }, {
                type: 5,
                name: '云闪付',
                tips: '仅支持从云闪付平台导出的txt文件',
                accept: '.txt',
                uploadLoading: false,
                fileName: "",
                beforeUpload: (file) => {
                    return this.beforeUpload(file, 'txt');
                },
                uploadFile: (file) => {
                    this.uploadFileAction(file, 5);
                }
            }]
        }
    },
    methods: {
        //展示
        show(time) {
            this.time = time;
            this.getUploadFileStatus();
            this.drawerShow = true;
        },
        //关闭
        close() {
            this.formData = { ..._defaultFormData };
            this.$nextTick(() => {
                this.forms.map((v, i) => {
                    this.$set(this.forms[i], 'fileName', "");
                })
                this.$refs["formData"] && this.$refs["formData"].clearValidate();
            })
            this.fileStatus = null;
            this.drawerShow = false;
        },
        //上传文件状态
        async getUploadFileStatus() {
            this.dataLoading = true;
            const res = await this.$request({
                url: "/finance/uploadFileStatus",
                method: "POST",
                params: {
                    date: this.time.replaceAll('-', '')
                },
            })
                .catch(err => {
                    return this.$message({ message: err.message, type: 'error' });
                })
                .finally(() => {
                    this.dataLoading = false;
                });
            const { state, msg, result } = res.data;
            if (state == 1) {
                this.fileStatus = result;
				console.log(this.fileStatus)
                this.forms.map(item => {
                    item.status = this.fileStatus.find(v => v.type == item.type).status;
                })
            } else {
                return this.$message.error(msg || '请求失败');
            }
        },
        //文件格式检测
        beforeUpload(file, _type) {
            const type = this.$utils.getFileType(file.name)
            const isType = type === _type;
            if (!isType) {
                this.$message.error(`仅支持${_type}文件格式,请重新选择上传文件!`);
            }
            return isType;
        },
        //文件上传
        async uploadFileAction(req, type) {
            this.$set(this.forms[type - 1], 'uploadLoading', true);
            this.$forceUpdate();

            const formData = new FormData();
            formData.append('file', req.file);

            const res = await uploadFile(formData).catch(err => {
                this.$message({ message: err.message, type: 'error' });
            }).finally(() => {
                this.$set(this.forms[type - 1], 'uploadLoading', false);
            });
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                this.formData[`path${type}`] = result.url;
                this.$set(this.forms[type - 1], 'fileName', req.file.name);
                this.$refs["formData"].clearValidate(`path${type}`);
            } else {
                this.$message.error(msg || '上传失败');
            }
            this.$forceUpdate();
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const _formData = [];
                    this.forms.map(v => {
                        if(v.fileName){
                            _formData.push({
                                date: this.time.replaceAll('-', ''),
                                path: this.formData[`path${v.type}`],
                                type: v.type
                            })
                        }
                    })
                    this.$request({
                        url: '/finance/manualUpload',
                        data: _formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            })
        }
    }
}
</script>